<template>
	<div>
		<div class="wrapper">
			<div class="columns">
				<div class="column-left">
					<div class="rte">
						<p>{{ this.$attrs.welcome_msg }}</p>
						<p v-if="variants.length === 0">
							{{ this.$attrs.empty_msg }}
						</p>
					</div>
				</div>
				<div class="column-right">
					<a v-if="variants.length !== 0" href="/account?wardrobe" class="btn btn-wide with-arrow">
						{{ this.$attrs.viewall_msg }}
					</a>
					<a v-if="variants.length === 0 && this.$attrs.new_in_coll === '1'" :href="this.$attrs.new_in_coll_url" class="btn btn-wide with-arrow">
						{{ this.$attrs.browsing_msg }}
					</a>
				</div>
			</div>
		</div>
		<div class="wardrobe-slider" v-if="variants.length > 0">
			<div class="wardrobe-slider-slideshow carousel" data-arrows>
				<div class="carousel-track" data-carousel-track>
					<div class="wardrobe-item" v-for="(node, k) in variants" :key="k" @click="toProduct(node)">
						<div class="product-image">
							<transition name="fade">
								<VImg
									v-show="node.image"
									:media="node.image"
									fixedSize="550x"
									class="product-item__main-img"
									:customClass="{ 'lazyload': true, 'remove-transition': 1 }" />
							</transition>
						</div>
						<div class="product-text">
							<p class="title">{{ node.product.title }}</p>
							<p v-show="node.product.vendor" class="vendor">{{ node.product.vendor }}</p>
							<p v-show="node.size" class="size">{{ node.size }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import VImg from './VImg'
import {FETCH_VARIANTS as QUERY } from '../../scripts/queries'

export default {
	name: "WardrobeSection",
	data: () => ({
		variants: [],
	}),
	components: { VImg },
	methods: {
		fetchWardrobe: function() {
			let prefix = `/a/ps/${window?.userInfo.id}/purchase_history?pre_page=20`
			this.$proxy.get(prefix).then(({data}) => {
				data.data.data
				let vids = data.data.data.map(v => btoa(`gid://shopify/ProductVariant/${v.vid}`))
				this.$gql.post('/api/2023-07/graphql.json', JSON.stringify({query: QUERY, variables: {vids}})).then(({data}) => {
					data.data.nodes.forEach(node => {
						let size_option = node.selectedOptions.find(val => val.name === 'size')
						node['size'] = size_option || null
						this.variants.push(node)
					})
				})
			})
		}
	},
	mounted: function () {
		this.fetchWardrobe()
	}
}
</script>
